
import { errorMessages } from "../../../assets/config";
import {qtyProxy} from "../../../../index";
import {CheckTechniqueSingleColor} from "./techniqueBaseOperations.ts";
import { getCurrentCanvas, getUpdatedHistory } from "../../../helpers/helper.ts";
import { updateCanvasWithAreaPosition } from "./printPositionDropDownController.ts";

function updateHistory() {
  let canvas =  getCurrentCanvas();
  let canvasHistory = JSON.parse(JSON.stringify(getUpdatedHistory()));

  if (canvasHistory.undoStatus === true || canvasHistory.redoStatus === true) {
    return;
  } 
  const jsonData = canvas.toJSON(["id", "selectable","controlsVisibility","libraryId","overlayImgScaleY","overlayImgScaleX"]);
  const canvasAsJson = JSON.stringify(jsonData);
  // NOTE: This is to replace the canvasHistory when it gets rewritten 20180912:Alevale
  if (canvasHistory.currentStateIndex < canvasHistory.state.length - 1) {
    const indexToBeInserted = canvasHistory.currentStateIndex + 1;
    canvasHistory.state[indexToBeInserted] = {
      canvasJson: canvasAsJson,
      PreLogoList: qtyProxy?.logoList,
    };
    const elementsToKeep = indexToBeInserted + 1;
    canvasHistory.state = canvasHistory.state.splice(0, elementsToKeep);
    // NOTE: This happens when there is a new item pushed to the canvasHistory (normal case) 20180912:Alevale
  } else {
    canvasHistory.state.push({
      canvasJson: canvasAsJson,
      PreLogoList: qtyProxy?.logoList,
    });
  }
  canvasHistory.currentStateIndex = canvasHistory.state.length - 1;
  updateCanvasWithAreaPosition(qtyProxy['selectedPositionIndex'],{
    ...qtyProxy['canvasListForPosition'][qtyProxy['selectedPositionIndex']],
    updatedHistory: canvasHistory
  })
  
}

function undo() {
  let canvas =  getCurrentCanvas();
  let canvasHistory = JSON.parse(JSON.stringify(getUpdatedHistory()));
  const index = canvasHistory.currentStateIndex - 1;
  if (index <= 0) {
    alert(errorMessages.UNDO_FINISH);
    return;
  }
  if (index == 1 && CheckTechniqueSingleColor()) {
    alert(errorMessages.UNDO_FINISH);
    return;
  }
  if (canvasHistory.undoFinishedStatus) {
    canvasHistory.undoFinishedStatus = false;
    canvasHistory.undoStatus = true;
    canvasHistory.currentStateIndex--;
    canvas.loadFromJSON(
      canvasHistory.state[canvasHistory.currentStateIndex].canvasJson,
      () => {
        qtyProxy["logoList"] =
          canvasHistory.state[canvasHistory.currentStateIndex].PreLogoList;
        canvas.renderAll();
        canvasHistory.undoStatus = false;
        canvasHistory.undoFinishedStatus = true;

        updateCanvasWithAreaPosition(qtyProxy['selectedPositionIndex'],{
          ...qtyProxy['canvasListForPosition'][qtyProxy['selectedPositionIndex']],
          updatedHistory: canvasHistory
        })

        canvas.getObjects().forEach((object) => {
          if (object.type === 'image') {
            object.setControlsVisibility({mt: false, ml: false, mr: false, mb: false})
          }
        })
      }
    );
  }
}

function redo() {
  let canvas =  getCurrentCanvas();
  let canvasHistory = JSON.parse(JSON.stringify(getUpdatedHistory()));
  if (canvasHistory.currentStateIndex + 1 === canvasHistory.state.length) {
    alert(errorMessages.REDO_FINISH);
    return;
  }

  if (canvasHistory.redoFinishedStatus) {
    canvasHistory.redoFinishedStatus = false;
    canvasHistory.redoStatus = true;
    canvas.loadFromJSON(
      canvasHistory.state[canvasHistory.currentStateIndex + 1].canvasJson,
      () => {
        qtyProxy["logoList"] =
          canvasHistory.state[canvasHistory.currentStateIndex + 1].PreLogoList;
        canvas.renderAll();
        canvasHistory.redoStatus = false;
        canvasHistory.currentStateIndex++;
        canvasHistory.redoFinishedStatus = true;

        updateCanvasWithAreaPosition(qtyProxy['selectedPositionIndex'],{
          ...qtyProxy['canvasListForPosition'][qtyProxy['selectedPositionIndex']],
          updatedHistory: canvasHistory
        })

        canvas.getObjects().forEach((object) => {
          if (object.type === 'image') {
            object.setControlsVisibility({mt: false, ml: false, mr: false, mb: false})
          }
        })
      }
    );

  }
}

export const initUndoRedoEventHandler = () => {
  updateCanvasWithAreaPosition(qtyProxy['selectedPositionIndex'],{
    ...qtyProxy['canvasListForPosition'][qtyProxy['selectedPositionIndex']],
    updatedHistory: JSON.parse(
      JSON.stringify(qtyProxy.initialHistory)
    ),
  })
  getCurrentCanvas().off("object:added", updateHistory);
  getCurrentCanvas().off("object:modified", updateHistory);

  getCurrentCanvas().on("object:added", updateHistory);
  getCurrentCanvas().on("object:modified", updateHistory);

  document.getElementById("undo").addEventListener("click", undo);
  document.getElementById("redo").addEventListener("click", redo);
};
